import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  src: PropTypes.string.isRequired,
};

const PlaygroundWidget = ({ src = "https://note.m0.quest/" }) => {
  console.log('PlaygroundWidget render:', { src }); // Debug statement

  return (
    <iframe
      id="etherpad-iframe"
      src={src}
      allow="clipboard-read; clipboard-write; microphone"
      title="Etherpad Widget"
      style={{ width: '100%', height: '100%', border: 'none' }}
    ></iframe>
  );
};

PlaygroundWidget.propTypes = propTypes;

export default PlaygroundWidget;


// WEBPACK FOOTER //
// ./src/templates/Challenges/components/PlaygroundWidget.js